import AxiosConfig from "./axiosConfig";

const axiosInstance = AxiosConfig();

export const RemovePatient = async (params) => {
  try {
    const response = await axiosInstance.post("deletePatient", params);
    console.log("params", params);

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      //Logout();
    }
    if (error.response && error.response.status === 500) {
      // window.location.href = "/luca";
      throw new Error("An error occurred.");
    }
  }
};
